// Constants for different requests for current reducer
export default {
  reset: 'RESET_ACTION_STATUS',
};
